export default __webpack_public_path__ + "static/media/IMG_0369.ba93fab4.PNG";